import { useState, useEffect } from 'react';

export function useTypingEffect(text, speed = 100) {
  const [typedText, setTypedText] = useState('');

  useEffect(() => {
    if (!text) return;
    let currentIndex = 0;
    setTypedText('');
    const intervalId = setInterval(() => {
      if (currentIndex < (text?.length || 0)) {
        setTypedText(text?.slice(0, currentIndex + 1) || '');
        currentIndex++;
      } else {
        clearInterval(intervalId);
      }
    }, speed);
    return () => clearInterval(intervalId);
  }, [text, speed]);

  return typedText;
}
